import { HomePage } from "./home";
import { CardLinkedOffersPage } from "./card-linked-offers";
import { CashbackRewardsPage } from "./cashback-rewards";
import { OnlineAffiliatesPage } from "./online-affiliates";
import { BillingPage, BillingPageTemplateProps } from "./billing";
import { PendingApprovalPage } from "./pending-approval";
import { ProfilePage } from "./profile";
import { TeamPage } from "./team";
import { PerksPage } from "./perks";
import { WelcomePage } from "./welcome";
import { GroupInsurancePage } from "./group-insurance";
import {
  AirdropPage,
  AirdropSelectMembersPage,
  AirdropSelectOfferPage,
  AirdropSelectAmountPage,
  AirdropConfirmPage,
  AirdropCompletePage,
} from "./airdrop";
import {
  CelebrationsBirthdayPage,
  CelebrationsCustomPage,
  CelebrationsHolidayPage,
  CelebrationsMainPage,
  CelebrationsSeniorityPage,
} from "./celebrations";
import {
  LifestyleMainPage,
  LifestyleCategoriesPage,
  LifestyleRulesPage,
  LifestyleConfirmPage,
  LifestyleCompletePage,
  LifestyleManageGroupPage,
  LifestyleTransactionsPage,
} from "./lifestyle";
import { OnboardingAddressPage } from "./onboarding-address";
import { UploadLogoPage } from "./upload-logo";
import { OnboardingAddCardPage } from "./onboarding-add-card";

export type PageProps =
  | { variant: "home" }
  | { variant: "cardLinkedOffers" }
  | { variant: "cashback-rewards"}
  | { variant: "onlineAffiliates" }
  | { variant: "billing" }
  | { variant: "pendingApproval" }
  | { variant: "profile" }
  | { variant: "team" }
  | { variant: "perks" }
  | { variant: "group-insurance" }
  | { variant: "welcome" }
  | { variant: "airdrop" }
  | { variant: "select-members" }
  | { variant: "select-offers" }
  | { variant: "select-amount" }
  | { variant: "airdrop-confirm" }
  | { variant: "airdrop-complete" }
  | { variant: "airdrop-history" }
  | { variant: "celebrations-main" }
  | { variant: "celebrations-birthday" }
  | { variant: "celebrations-holiday" }
  | { variant: "celebrations-seniority" }
  | { variant: "celebrations-custom" }
  | { variant: "lifestyle-main" }
  | { variant: "lifestyle-categories" }
  | { variant: "lifestyle-rules" }
  | { variant: "lifestyle-confirm" }
  | { variant: "lifestyle-complete" }
  | { variant: "lifestyle-manage-group" }
  | { variant: "lifestyle-transactions" }
  | { variant: "onboarding-address" }
  | { variant: "upload-logo" }
  | { variant: "onboarding-add-card" };

export const Page = (props: PageProps): JSX.Element => {
  switch (props.variant) {
    case "home":
      return <HomePage />;
    case "cardLinkedOffers":
      return <CardLinkedOffersPage />;
    case "cashback-rewards":
      return <CashbackRewardsPage />;
    case "onlineAffiliates":
      return <OnlineAffiliatesPage />;
    case "billing":
      return <BillingPage />;
    case "pendingApproval":
      return <PendingApprovalPage />;
    case "profile":
      return <ProfilePage />;
    case "team":
      return <TeamPage />;
    case "perks":
      return <PerksPage />;
    case "group-insurance":
      return <GroupInsurancePage />;
    case "welcome":
      return <WelcomePage />;
    case "airdrop":
      return <AirdropPage />;
    case "select-members":
      return <AirdropSelectMembersPage />;
    case "select-offers":
      return <AirdropSelectOfferPage />;
    case "select-amount":
      return <AirdropSelectAmountPage />;
    case "airdrop-confirm":
      return <AirdropConfirmPage />;
    case "airdrop-complete":
      return <AirdropCompletePage />;
    case "celebrations-main":
      return <CelebrationsMainPage />;
    case "celebrations-birthday":
      return <CelebrationsBirthdayPage />;
    case "celebrations-holiday":
      return <CelebrationsHolidayPage />;
    case "celebrations-seniority":
      return <CelebrationsSeniorityPage />;
    case "celebrations-custom":
      return <CelebrationsCustomPage />;
    case "lifestyle-main":
      return <LifestyleMainPage />;
    case "lifestyle-categories":
      return <LifestyleCategoriesPage />;
    case "lifestyle-rules":
      return <LifestyleRulesPage />;
    case "lifestyle-confirm":
      return <LifestyleConfirmPage />;
    case "lifestyle-complete":
      return <LifestyleCompletePage />;
    case "lifestyle-manage-group":
      return <LifestyleManageGroupPage />;
    case "lifestyle-transactions":
      return <LifestyleTransactionsPage />;
    case "onboarding-address":
      return <OnboardingAddressPage />;
    case "upload-logo":
      return <UploadLogoPage />;
    case "onboarding-add-card":
      return <OnboardingAddCardPage />;
    default:
      throw new Error(`[SIGN UP ERROR]: Invalid variant provided`);
  }
};
